import { useState } from "react";
import { useSelector } from "react-redux";
import { ThemedFilterIcon } from "assets/CXFIcons/Designer/ContextActions";
import FilterDialog from "./FilterDialog";
import ContextHeaderButton from "../ContextHeaderButton";

const FilterButton = () => {
  const [open, setOpen] = useState(false);
  const { contextFilterOptions } = useSelector((store) => store?.designer?.editorContext);

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleFilterClick = () => {
    setOpen(true);
  };

  const checkActiveFilters = () => {
    return Object.values(contextFilterOptions).some((value) => !value);
  }

  return (
    <>
      <ContextHeaderButton
        icon={<ThemedFilterIcon className={checkActiveFilters() ? "active" : ""} />}
        label="Filter"
        action={handleFilterClick}
      />
      <FilterDialog open={open} onClose={handleCloseDialog} />
    </>
  );
};

export default FilterButton;
